import _ from "lodash";

var midi: any = null; // global MIDIAccess object

function getMidiAccess() {
    if (!midi) {
        // console.error('MIDI access not initialized');
        return null;
    }

    return midi;
}

function onMIDISuccess(midiAccess) {
    console.log("MIDI ready!");
    midi = midiAccess; // store in the global (in real usage, would probably keep in an object instance)
}

function onMIDIFailure(msg) {
    console.error(`Failed to get MIDI access - ${msg}`);
}

type MidiDeviceInfo = {
    type: string,
    id: string,
    manufacturer: string,
    name: string,
    version: string
};

function listMidiDevices(source): MidiDeviceInfo[] {
    const devices: MidiDeviceInfo[] = [];

    if (!source) return devices;

    for (const entry of source) {
        const e = entry[1];
        devices.push({
            type: e.type,
            id: e.id,
            manufacturer: e.manufacturer,
            name: e.name,
            version: e.version,
        });
    }

    return devices;
}

function listInputs(midiAccess): MidiDeviceInfo[] {
    return listMidiDevices(midiAccess?.inputs);
}

function listOutputs(midiAccess): MidiDeviceInfo[] {
    return listMidiDevices(midiAccess?.outputs);
}

/**
 * Starts logging MIDI input from the specified device.
 * @param midiAccess
 * @param param1
 * @param onMidiMessageCB
 * @returns
 */
function startLoggingMIDIInput(midiAccess, { inputId }, onMidiMessageCB) {

    if (!midiAccess || !midiAccess.inputs) {
        console.error('No MIDI inputs available');
        return;
    }

    const midiInput = midiAccess.inputs.get(inputId);
    if (!midiInput) {
        console.error(`No MIDI input found with id ${inputId}`);
        return;
    }
    // console.log('>>> start midi event logging', midiAccess, 'input id', inputId);
    midiInput.onmidimessage = onMidiMessageCB;
}

function stopLoggingMIDIInput(midiAccess, { inputId }) {

    if (!midiAccess || !midiAccess.inputs) {
        console.error('No MIDI inputs available');
        return;
    }

    const dev = midiAccess.inputs.get(inputId);
    if (!dev) return;

    // console.log('>>> stop midi event logging', midiAccess, 'input id', inputId);
    dev.onmidimessage = null;
}

function init(successCB) {
    console.log('Midi access init');
    // navigator.requestMIDIAccess().then(successCB, onMIDIFailure);
    navigator["requestMIDIAccess"]().then((midiAccess) => {
        console.log('midi access granted', midiAccess);
        console.log(midiAccess, typeof midiAccess);
        midi = midiAccess;
        successCB(getMidiAccess());

    }, onMIDIFailure);
}

export {
    init,
    listInputs,
    listOutputs,
    startLoggingMIDIInput,
    stopLoggingMIDIInput,
    // getMidiAccess,
};